
app.header = (function (module) {
        module.init = function ($el) {
            var header = document.getElementById("header");
            var newNav = null;
            var headerOffset = header.offsetTop + 150;

            var createNav2 = function () {
                var page = document.getElementById('page');
                var nav = document.getElementById('nav');
                var newNav = nav.cloneNode(true);
                newNav.setAttribute('id', 'nav2');
                page.insertBefore(newNav, page.firstChild);
                return newNav;
            }

            var removeNav2 = function() {
                var newNav = document.getElementById('nav2');
                newNav.parentNode.removeChild(newNav);
            }

            var recalculateNavs = function () {
                var vw = window.innerWidth;
                var isMobile = vw < 615;
                newNav = document.getElementById('nav2');

                if (!isMobile && !newNav) {
                    newNav = createNav2();
                } else if (isMobile && newNav) {
                    removeNav2();
                }

                var criticalNav = isMobile ? header : newNav;
                if (window.pageYOffset > headerOffset) {
                    criticalNav.classList.add('scroll');
                } else {
                    criticalNav.classList.remove('scroll');
                }
            }

            document.addEventListener("scroll", function (e) {
                recalculateNavs();
            }, {passive: true});

            window.addEventListener('resize', function () {
                recalculateNavs();
            }, {passive: true});
        }


        return module;
    }(app.header || {})
);
